import { Capacitor } from "@capacitor/core";

import { baseUrl, headersDefault } from "../redux/actions";
import { TERMS_PRIVACY_CONSENT } from "../constants/purchaseConsents";

/**
 * Keeps the proof that the member ticked the Termini e Condizioni / Informativa
 * Privacy confirmation, just before the Apple / Google sheet opens.
 *
 * Resolves true when the purchase may go ahead. A backend that predates the
 * endpoint (404) does not block the purchase — the member did tick the box;
 * only the server-side copy is missing until it is deployed. Any other failure
 * stops it, so a purchase never goes through without its proof by accident.
 *
 * @param {string} productId the store product identifier about to be bought
 * @returns {Promise<boolean>}
 */
// Premium Lite: one paid plan at a time. The backend refuses a store purchase
// while another paid plan runs (409 + a message for the member); the caller
// shows that message instead of the generic retry one.
let lastRefusalMessage = null;

export const takePurchaseRefusalMessage = () => {
  const message = lastRefusalMessage;
  lastRefusalMessage = null;
  return message;
};

export const recordStorePurchaseConsent = async (productId) => {
  lastRefusalMessage = null;
  try {
    const response = await fetch(`${baseUrl}/api/v1/billing/consents`, {
      method: "POST",
      headers: headersDefault(),
      body: JSON.stringify({
        product_id: String(productId ?? ""),
        platform: Capacitor.getPlatform(),
        consents: [TERMS_PRIVACY_CONSENT],
      }),
    });

    if (response.ok) return true;

    if (response.status === 409) {
      try {
        const body = await response.json();
        lastRefusalMessage = body?.message || body?.error?.message || null;
      } catch {
        lastRefusalMessage = null;
      }
      return false;
    }

    if (response.status === 404) {
      console.warn("[PurchaseConsents] billing/consents not deployed yet");
      return true;
    }

    console.warn("[PurchaseConsents] could not record", response.status);
    return false;
  } catch (error) {
    console.warn("[PurchaseConsents] could not record", error);
    return false;
  }
};
